import { Ban } from "lucide-react";

interface Props {
  blockedByMe?: boolean;
  blockedMe?: boolean;
  onUnblock?: () => void;
  participantName?: string;
}

const BlockedMessageFooter: React.FC<Props> = ({
  blockedByMe,
  blockedMe,
  onUnblock,
  participantName,
}) => {
  if (blockedMe) {
    return (
      <div className="p-4 text-center text-sm text-gray-600 bg-white border-t flex items-center justify-center gap-2">
        <Ban size={16} className="text-red-500" />
        You can’t send messages to this conversation.
      </div>
    );
  }

  if (blockedByMe) {
    return (
      <div className="bg-white border-t px-4 py-3 text-center text-sm text-gray-600">
        <div className="flex items-center justify-center gap-2">
          <Ban size={16} className="text-yellow-600 shrink-0" />

          <span>
            You can’t send messages to{" "}
            <span className="font-medium text-gray-900">{participantName}</span>{" "}
            because you’ve blocked this contact.
          </span>
        </div>

        <button
          onClick={onUnblock}
          className="mt-1 text-sm font-medium text-[var(--primary-700)] hover:underline"
        >
          Unblock {participantName} ?
        </button>
      </div>
    );
  }

  return null;
};

export default BlockedMessageFooter;
